import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { bulkUploadCustomers } from "../services/ApiService";

function BulkUploadCustomer() {
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const res = await bulkUploadCustomers(formData);
      alert(res.data.message);
      if (res.data.success) handleClose();
    } catch (err) {
      alert("Upload failed.");
      console.error(err);
    }
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Bulk Upload Customer
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Upload Excel File</DialogTitle>
        <DialogContent>
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFileChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleUpload} variant="contained" color="primary">
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BulkUploadCustomer;
